import { useEffect, useState } from 'react';

import type { TouchpointSourceType } from '@trello/ad-sequencer';

import { getAvailableSites } from '../../getAvailableSites';
import type { RuntimeEligibilityCheckResult } from './RuntimeEligibilityCheck';

export const useHasNoAvailableSites = ({
  doLoadAvailableSites,
  source,
}: {
  doLoadAvailableSites: boolean;
  source: TouchpointSourceType;
}): RuntimeEligibilityCheckResult => {
  const [loadingAvailableSites, setLoadingAvailableSites] = useState(false);

  const [hasNoAvailableSites, setHasNoAvailableSites] = useState(false);

  useEffect(() => {
    const loadSiteEligibility = async () => {
      try {
        setLoadingAvailableSites(true);
        const { sites } = await getAvailableSites();
        const hasNoSites =
          sites?.length > 0 &&
          sites?.filter(({ cloudId }) => cloudId !== 'TRELLO').length === 0;
        setHasNoAvailableSites(hasNoSites);
      } finally {
        setLoadingAvailableSites(false);
      }
    };

    if (doLoadAvailableSites && !loadingAvailableSites) {
      loadSiteEligibility();
    }
    // Intentionally ignoring loadingAvailableSites dependency
    // eslint-disable-next-line @trello/exhaustive-deps
  }, [source, doLoadAvailableSites]);

  return {
    isEligible: hasNoAvailableSites,
  };
};
